const vh = (input) => {
	const base = 937;

	let output = input / base * $('.game__canvas').outerHeight();

	return output;
};

const game = {
	$canvas: $('.game__canvas'),
	$wrapper: $('.game__canvas__wrapper'),
	$person: $('.game__canvas__person'),
	$wheel: $('.game__canvas__person__wheel'),
	$wheelRotate: $('.game__canvas__person__wheel__rotate'),
	$wheelCollision: $('.game__canvas__person__wheel__collision'),
	$jumpButton: $('.game__canvas__jump'),
	canvasWidth: 0,
	windowWidth: $('.game__canvas').outerWidth(),
	speed: vh(1),
	speedMax: vh(20),
	distance: 0,
	wheelRotate: 0,
	wheelRotateSpeed: 0,
	wheelRotateSpeedMax: 6,
	personY: 0,
	personScale: 1,
	wheelY: 0,
	jumpDisable: false,
	processing: null,
	paused: false,
	playing: false,
	$enemy: $('.game__canvas__enemies__item'),
	$enemyNext: $('.game__canvas__enemies__item').eq(0),
	enemyNextType: $('.game__canvas__enemies__item').eq(0).data('type'),
	enemyLength: $('.game__canvas__enemies__item').length,
	enemyCount: 0,
	init() {
		// game.timer();
		game.setDefaults();
		game.handlers();
	},
	reload() {
		game.setDefaults();
	},
	setDefaults() {
		game.$canvas = $('.game__canvas');
		game.$wrapper = $('.game__canvas__wrapper');
		game.$person = $('.game__canvas__person');
		game.$wheel = $('.game__canvas__person__wheel');
		game.$wheelRotate = $('.game__canvas__person__wheel__rotate');
		game.$wheelCollision = $('.game__canvas__person__wheel__collision');
		game.$jumpButton = $('.game__canvas__jump');
		game.canvasWidth = 0;
		game.windowWidth = $('.game__canvas').outerWidth();
		game.speed = vh(1);
		game.speedMax = vh(20);
		game.distance = 0;
		game.wheelRotate = 0;
		game.wheelRotateSpeed = 0;
		game.wheelRotateSpeedMax = 6;
		game.personY = 0;
		game.personScale = 1;
		game.wheelY = 0;
		game.jumpDisable = false;
		game.processing = null;
		game.paused = false;
		game.playing = false;
		game.$enemy = $('.game__canvas__enemies__item');
		game.$enemyNext = $('.game__canvas__enemies__item').eq(0);
		game.enemyNextType = $('.game__canvas__enemies__item').eq(0).data('type');
		game.enemyLength = $('.game__canvas__enemies__item').length;
		game.enemyCount = 0;
		game.duration = 0.05;
	},
	timer() {
		const $items = $('.game__timer__item');

		let counter = $items.length;

		$('.game').addClass('is-timer');

		const timer = () => {
			if (counter === 0) {
				$items.removeClass('is-active');
				$('.game').removeClass('is-timer');
				setTimeout(() => {
					game.start();
				}, 500);
			} else {
				$items.removeClass('is-active');
				$items.filter(`[data-item="${counter}"]`).addClass('is-active');
				counter -= 1;
				setTimeout(() => {
					timer();
				}, 1500);
			}
		};
		$('.game').removeClass('is-preview-visible');
		setTimeout(() => {
			$('.game').removeClass('is-preview');
			timer();
		}, 500);
	},
	start() {
		game.play();
		game.playing = true;
		game.$jumpButton.removeClass('is-disabled');
	},
	play() {
		game.processing = setInterval(() => {
			game.canvasWidth = game.$wrapper.outerWidth();

			game.distance += game.speed;
			if (game.speed < game.speedMax) {
				game.speed += vh(0.5);
			} else {
				game.speed = game.speedMax;
			}
			if (game.wheelRotateSpeed < game.wheelRotateSpeedMax) {
				game.wheelRotateSpeed += 0.2;
			}
			game.wheelRotate += game.wheelRotateSpeed;
			if (game.distance + game.windowWidth < game.canvasWidth) {
				gsap.to(game.$wrapper, {
					x: -game.distance,
					duration: game.duration,
					rotation: 0.002,
					force3D: true,
					immediateRender: true,
					ease: Power0.easeNone,
				});
			}
			gsap.to(game.$person, {
				y: game.personY,
				x: game.distance,
				scale: game.personScale,
				rotation: 0.01,
				force3D: true,
				duration: game.duration,
				immediateRender: true,
				ease: Power0.easeNone,
			});
			gsap.to(game.$wheel, {
				y: game.wheelY,
				duration: game.duration,
				rotation: 0.01,
				force3D: true,
				immediateRender: true,
				ease: Power0.easeNone,
			});
			gsap.to(game.$wheelRotate, {
				rotation: game.wheelRotate,
				duration: game.duration,
				force3D: true,
				immediateRender: true,
				ease: Power0.easeNone,
			});

			if (game.$enemyNext !== false) {
				if (game.crashed()) {
					game.crash();
				}
				game.enemyCounter();
			}

			if (game.distance > game.canvasWidth) {
				game.win();
			}
		}, 1000 / 30);
	},
	avoid() {
		const $currentEnemyAction = game.$enemyNext.find('.game__canvas__enemies__item__action');

		if (game.$enemyNext !== false && game.enemyNextType === 'detour' && game.$wheelCollision.offset().left + game.$wheelCollision.outerWidth() >= $currentEnemyAction.offset().left) {
			if (game.$wheelCollision.offset().left + game.$wheelCollision.outerWidth() <= $currentEnemyAction.offset().left + $currentEnemyAction.outerWidth()) {
				game.detour();
				game.$enemyNext.addClass('is-passed');
			}
		} else {
			game.jump();
		}
	},
	jump(force = false) {
		if ((!game.jumpDisable && game.playing) || force) {
			game.jumpDisable = true;
			let x = 0;
			let speed = vh(28);
			let direction = 'up';

			let jumping = setInterval(() => {
				if (!game.paused && game.playing) {
					if (direction === 'up') {
						x -= speed;
						speed -= vh(1);

						if (speed <= vh(0.1)) {
							speed = vh(4);
						}
						if (x <= vh(-350)) {
							direction = 'down';
							speed = vh(10);
						}
					}
					if (direction === 'down') {
						x += speed;
						speed += vh(2);

						if (speed >= vh(40)) {
							speed = vh(40);
						}
					}
					game.wheelY = x;
					if (x >= 0) {
						clearTimeout(jumping);

						game.wheelY = 0;

						setTimeout(() => {
							game.jumpDisable = false;
						}, 100);
					}
				}
				if (!game.playing) {
					clearTimeout(jumping);
					game.jumpDisable = false;
				}
			}, 1000 / 30);
		}
	},
	detour() {
		if (!game.jumpDisable && game.playing) {
			game.jumpDisable = true;
			let y = 0;
			let speed = vh(28);

			const end = () => {
				let jumping = setInterval(() => {
					if (!game.paused && game.playing) {
						y += speed;
						speed += 1;

						if (speed >= vh(25)) {
							speed = vh(25);
						}
						game.personY = y;
						game.personScale = 1;
						if (y >= 0) {
							clearTimeout(jumping);

							game.personY = 0;

							setTimeout(() => {
								game.jumpDisable = false;
							}, 100);
						}
					}
				}, 1000 / 30);
			};

			const checkEnd = () => {
				const $currentEnemyEnd = game.$enemyNext.find('.game__canvas__enemies__item__end');

				let jumping = setInterval(() => {
					if (game.$wheelCollision.offset().left + game.$wheelCollision.outerWidth() >= $currentEnemyEnd.offset().left) {
						clearInterval(jumping);
						end();
					}
				});
			};

			const start = () => {
				let jumping = setInterval(() => {
					if (!game.paused && game.playing) {
						y -= speed;
						speed -= vh(1);

						if (speed <= vh(1)) {
							speed = vh(1);
						}
						if (y <= vh(-75)) {
							speed = vh(10);
							clearTimeout(jumping);
							checkEnd();
						}
						game.personY = y;
						game.personScale = 0.8;
					}
				}, 1000 / 30);
			};
			let detourReadyInterval = setInterval(() => {
				const $currentEnemyStart = game.$enemyNext.find('.game__canvas__enemies__item__start');

				if (game.$wheelCollision.offset().left + game.$wheelCollision.outerWidth() >= $currentEnemyStart.offset().left) {
					clearInterval(detourReadyInterval);
					start();
				}
			}, 1000 / 30);
			game.jump(true);
		}
	},
	crashed() {
		const $currentEnemy = game.$enemyNext.find('.game__canvas__enemies__item__collision');

		if (game.$wheelCollision.offset().left < $currentEnemy.offset().left + $currentEnemy.outerWidth() && game.$wheelCollision.offset().left + game.$wheelCollision.outerWidth() > $currentEnemy.offset().left && game.$wheelCollision.offset().top < $currentEnemy.offset().top + $currentEnemy.outerHeight() && game.$wheelCollision.outerHeight() + game.$wheelCollision.offset().top > $currentEnemy.offset().top) {
			return true;
		}

		return false;
	},
	enemyCounter() {
		const $currentCollision = game.$enemyNext.find('.game__canvas__enemies__item__collision');

		if ($currentCollision.offset().left + $currentCollision.outerWidth() < game.$person.offset().left) {
			game.$enemyNext.addClass('is-passed');
			game.enemyCount++;
			game.$enemyNext = game.$enemy.eq(game.enemyCount);
			if (!game.$enemyNext.length) {
				game.$enemyNext = false;
				game.enemyNextType = 'jump';
			} else {
				game.enemyNextType = game.$enemyNext.data('type');
			}
		}
	},
	win() {
		clearInterval(game.processing);

		game.playing = false;
		game.$jumpButton.addClass('is-disabled');

		$('.game').addClass('is-win');
		setTimeout(() => {
			$('.game').addClass('is-win-visible');
		}, 50);
	},
	crash() {
		const roll = () => {
			let distance = 0;
			let distanceMax = vh(250);

			let rolling = setInterval(() => {
				distance += vh(5);
				game.wheelRotate -= 3;

				gsap.to(game.$wrapper, {
					x: -game.distance + distance,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				gsap.to(game.$person, {
					y: 0,
					x: game.distance - distance,
					scale: game.personScale,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				gsap.to(game.$wheelRotate, {
					rotation: game.wheelRotate,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				if (distance >= distanceMax) {
					clearTimeout(rolling);
					game.loss();
				}
			}, 1000 / 30);
		};

		const jump = () => {
			let x = 0;
			let speed = vh(28);
			let direction = 'up';

			let jumping = setInterval(() => {
				game.distance -= vh(15);
				if (direction === 'up') {
					x -= speed;
					speed -= vh(1);

					if (speed <= vh(0.1)) {
						speed = vh(4);
					}
					if (x <= vh(-150)) {
						direction = 'down';
						speed = vh(10);
					}
				}
				if (direction === 'down') {
					x += speed;
					speed += vh(2);

					if (speed >= vh(40)) {
						speed = vh(40);
					}
				}

				gsap.to(game.$wrapper, {
					x: -game.distance,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				gsap.to(game.$person, {
					y: 0,
					x: game.distance,
					scale: game.personScale,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				gsap.to(game.$wheel, {
					y: x,
					duration: 0.1,
					immediateRender: true,
					ease: Power0.easeNone,
				});
				if (x >= 0) {
					clearTimeout(jumping);

					gsap.to(game.$wheel, {
						y: 0,
						duration: 0.1,
						immediateRender: true,
						ease: Power0.easeNone,
					});

					roll();
				}
			}, 1000 / 30);
		};

		game.playing = false;

		clearInterval(game.processing);
		jump();
	},
	loss() {
		$('.game').addClass('is-loss');
		setTimeout(() => {
			$('.game').addClass('is-loss-visible');
		}, 50);
	},
	pause() {
		clearInterval(game.processing);
		game.paused = true;
	},
	unpause() {
		if (game.playing) {
			game.play();
		}
		game.paused = false;
	},
	handlers() {
		$(document).on('keydown.game', (e) => {
			if (e.keyCode === 80) {
				e.preventDefault();
				if (game.paused) {
					game.unpause();
				} else {
					game.pause();
				}
			}
			if (e.keyCode === 32) {
				e.preventDefault();
				game.avoid();
			}

			if (e.keyCode === 67) {
				e.preventDefault();
				if (window.localStorage.showCollision !== '1') {
					window.localStorage.showCollision = '1';
					$('.game').addClass('is-show-collision');
				} else {
					window.localStorage.showCollision = '0';
					$('.game').removeClass('is-show-collision');
				}
			}
		});

		game.$jumpButton.on('click.game', (e) => {
			e.preventDefault();
			game.avoid();
		});

		$('.game__preview__start button').on('click.game', (e) => {
			e.preventDefault();

			game.timer();
		});

		$(window).on('resize.game', () => {
			game.windowWidth = $('.game__canvas').outerWidth();
			setTimeout(() => {
				game.speedMax = vh(20);
			}, 150);
		}).on('orientationchange.game', () => {
			if (window.orientation === 0 || window.orientation === 180) {
				game.pause();
			} else if (game.paused) {
				game.unpause();
			}
		});

		$('.game__share__toggle').on('click.game', (e) => {
			e.preventDefault();
			$('.game__share').toggleClass('is-show');
		});

		$('.js-game-reload').on('click.game', (e) => {
			e.preventDefault();
			game.destroy();
			game.init();
		});

		$('.js-game-change').on('click.game', (e) => {
			e.preventDefault();
			$.ajax({
				type: 'get',
				url: `./${$(e.currentTarget).data('type')}-ajax.html`,
				success(response) {
					$('.home__route__game').html(response);
					$('.home__route').addClass('is-show-game');
					game.init();
					window._goodshare.reNewAllInstance();
				},
			});
		});
	},
	destroy() {
		game.playing = false;
		clearInterval(game.processing);
		$(document).off('keydown.game');
		$(window).off('resize.game orientationchange.game');
		game.$jumpButton.off('click.game');
		$('.game__preview__start button').off('click.game');
		$('.game__share__toggle').off('click.game');
		$('.js-game-reload').off('click.game');
		gsap.to(game.$wrapper, {
			x: 0,
			duration: 0,
			rotation: 0.002,
			force3D: true,
			immediateRender: true,
			ease: Power0.easeNone,
		});
		gsap.to(game.$person, {
			y: 0,
			x: 0,
			scale: game.personScale,
			rotation: 0.01,
			force3D: true,
			duration: 0,
			immediateRender: true,
			ease: Power0.easeNone,
		});
		gsap.to(game.$wheel, {
			y: 0,
			duration: 0,
			rotation: 0.01,
			force3D: true,
			immediateRender: true,
			ease: Power0.easeNone,
		});
		gsap.to(game.$wheelRotate, {
			rotation: 0,
			duration: 0,
			force3D: true,
			immediateRender: true,
			ease: Power0.easeNone,
		});
		$('.game__canvas__enemies__item').removeClass('is-passed');
		$('.game').addClass('is-timer is-preview is-preview-visible');
		$('.game').removeClass('is-win is-win-visible is-loss is-loss-visible');
	},
};

if (game.$canvas.length) {
	game.init();
}

export default game;
